export default __webpack_public_path__ + "static/media/plain-sticker-by.a4796892.png";